var prfx = 'acom_';

acom_app.models.Settings = acom_app.BaseNestedModel.extend({
    action: prfx + 'settings',
    // initialize: function () {
    //     this.set(this.defaults())
    // },
    defaults: function () {
        var helper = acom_app.models.helper
        var menus = Object.keys(helper.get('menus'))
        return {
            custom_css: '/* You can add your own CSS here. */',
            general: {
                display_auth: 'everyone',
                display_desktop: '1',
                display_mobile: '1',
                display_default_pages: ['front', 'home', 'archives', 'single', 'forbidden', 'search'],
                display_pages: Object.keys(helper.get('pages')),
                display_post_types: helper.get('post_types').map(function (item, i) {
                    return item.name
                }),
                display_categories: Object.keys(helper.get('categories')).map(function (item) {
                    return item
                }),
                capabilities: 'manage_options',
                admin_bar: '1',

                search_titles: '1',
                search_content: '1',
                search_fields: '1',
                search_comments: '1',
                search_post_types: helper.get('post_types').map(function (item, i) {
                    return item.name
                }),
                search_categories: Object.keys(helper.get('categories')).map(function (item) {
                    return item
                }),
                search_pages_exclude: ''
            },
            content: {
                menu_logo: '1',
                menu_logo_type: 'text',
                menu_logo_text: helper.get('site_title'),
                menu_logo_image: '',
                menu_menu: '1',
                menu_menu_slug: menus.length > 0 ? menus[0] : '',
                menu_search: '1',
                menu_button: '0',
                menu_button_label: 'Click me',
                menu_button_url: '',
                menu_social: '0',

                search_results: '1',
                search_menu: '0',
                search_menu_slug: menus.length > 0 ? menus[0] : '',

                panel_logo: '0',
                panel_logo_type: 'text',
                panel_logo_text: helper.get('site_title'),
                panel_logo_image: '',
                panel_text: '',
                panel_login: '0',
                panel_subscribe: '0',
                panel_subscribe_button_text: 'Sign up',
                panel_subscribe_welcome_text: 'Sign up for our newsletter today!',
                panel_subscribe_success_text: 'Thank you for subscribing!',
                panel_subscribe_fail_text: 'Something went wrong',
                panel_cart: '0',

                panel_menu: '1',
                panel_menus: [
                    {
                        slug: menus.length > 0 ? menus[0] : '',
                        rule: 'all'
                    }
                ],
                panel_search: '1',
                panel_social: '1',
                panel_footer: ''
            },
            accounts: {
                social: [
                    {
                        type: 'icon',
                        icon: 'facebook',
                        image: '',
                        label: 'Facebook',
                        url: ''
                    }
                ],
                mailchimp_key: '',
                mailchimp_list: '',
            },
            styles: {
                general_mode: 'menu',

                button_fixed: '1',
                button_mode: 'icon',
                button_position: 'right',
                button_size: '46',
                button_shift_v: '10',
                button_shift_h: '10',
                button_shape: 'square',
                button_shadow: '0',
                button_shadow_type: 'blurred',
                button_text: 'Menu',
                button_text_family: 'inherit',
                button_text_size: '16px',
                button_text_weight: '400',
                button_text_style: 'normal',
                button_text_transform: 'none',
                button_text_color: '#FFFFFF',
                button_text_hover_color: 'rgba(255,255,255,0.6)',
                button_bg: '0',
                button_bg_color: '#222222',
                button_bg_hover_color: 'rgba(255,255,255,0.9)',
                button_border: '0',
                button_border_size: '1',
                button_border_color: '#000000',
                button_border_hover_color: 'rgba(0,0,0,0.9)',

                menu_height: '80',
                menu_adaptive_height: '0',
                menu_adaptive_height_amount: '80',
                menu_adaptive_height_treshold: '200',
                menu_fixed: '0',
                menu_push: '0',
                menu_fixed_treshold: '0',
                menu_transparent: '0',
                menu_transparent_treshold: '100',
                menu_image: '',
                menu_image_position: 'center',
                menu_color: '#333545',
                menu_dropdown_color: '#333545',
                menu_border: '0',
                menu_border_color: '#000',
                menu_shadow: '0',
                menu_mobile_treshold: '780',

                hidden_trigger: '',
                hidden_target: 'panel',

                menu_logo_text_family: 'inherit',
                menu_logo_text_color: '#FFFFFF',
                menu_logo_text_hover_color: 'rgba(255,255,255,0.6)',
                menu_logo_text_size: '20px',
                menu_logo_text_weight: '400',
                menu_logo_text_style: 'normal',
                menu_logo_text_transform: 'none',
                menu_logo_shadow: '0',

                menu_menu_align: 'right',
                menu_menu_text_family: 'inherit',
                menu_menu_text_color: '#FFFFFF',
                menu_menu_text_hover_color: 'rgba(255,255,255,0.6)',
                menu_menu_text_size: '16px',
                menu_menu_text_weight: '400',
                menu_menu_text_style: 'normal',
                menu_menu_text_transform: 'none',
                menu_menu_shadow: '0',

                menu_social_size: '45',
                menu_social_shape: 'rounded',
                menu_social_color: '#fff',

                search_button_type: 'button',
                search_button_label: 'Search...',
                search_button_size: '22',
                search_button_color: '#FFFFFF',
                search_button_bg_color: '#DF8BB0',
                search_button_animation: '1',

                menu_button_height: '30',
                menu_button_shape: 'rounded',
                menu_button_text_color: '#fff',
                menu_button_bg_color: '#2888b7',
                menu_button_border_color: '#2888b7',
                menu_button_text_hover_color: '#fff',
                menu_button_bg_hover_color: '#195a79',
                menu_button_border_hover_color: '#195a79',


                search_results_label: 'Results',
                search_results_align: 'left',
                search_results_text_family: 'inherit',
                search_results_text_color: '#FFFFFF',
                search_results_text_hover_color: 'rgba(255,255,255,0.6)',
                search_results_text_size: '16px',
                search_results_text_weight: '400',
                search_results_text_style: 'normal',
                search_results_text_transform: 'none',
                search_results_thumbs_visible: '1',
                search_results_thumbs_size: '50',
                search_results_title_visible: '1',
                search_results_excerpt_visible: '1',
                search_results_author_visible: '1',
                search_results_comments_visible: '1',
                search_results_date_visible: '1',

                search_menu_label: 'Quick Links',
                search_menu_list_type: 'none',
                search_menu_align: 'right',
                search_menu_text_family: 'inherit',
                search_menu_text_color: '#000000',
                search_menu_text_hover_color: 'rgba(0,0,0,0.7)',
                search_menu_text_size: '16px',
                search_menu_text_weight: '400',
                search_menu_text_style: 'normal',
                search_menu_text_transform: 'none',

                panel_width: '260',
                panel_text_color: '#fff',
                panel_bg_color: '#333545',
                panel_image: '',

                panel_subscribe_field_color: '#000',
                panel_subscribe_text_color: '#000',
                panel_subscribe_button_color: '#000',

                panel_menu_align: 'center',
                panel_menu_text_family: 'inherit',
                panel_menu_text_color: '#FFFFFF',
                panel_menu_text_hover_color: 'rgba(255,255,255,0.6)',
                panel_menu_bg_hover_color: 'rgba(70, 72, 95, 0.77)',
                panel_menu_text_size: '16px',
                panel_menu_text_weight: '400',
                panel_menu_text_style: 'normal',
                panel_menu_text_transform: 'none',
                panel_menu_gaps: '0.5em',

                panel_social_size: '35',
                panel_social_shape: 'round',
                panel_social_color: '#fff',
            }
        }
    },
    fields: {
        custom_css: {
            type: 'textarea',
            class: 'col-md-12',
            label: '',
            rows: 22
        },

        // General
        general: {
            // Visibility
            display_auth: {
                type: 'chooser',
                label: 'Show for',
                variants: {
                    everyone: 'All',
                    logged: 'Users',
                    guests: 'Guests'
                }
            },
            display_desktop: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Show menu on Desktop'
            },
            display_mobile: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Show menu on Mobiles'
            },
            display_default_pages: {
                type: 'hidden',
                hold: 'switcher'
            },
            display_pages: {
                type: 'hidden',
                hold: 'switcher'
            },
            display_post_types: {
                type: 'hidden',
                hold: 'switcher'
            },
            display_categories: {
                type: 'hidden',
                hold: 'switcher'
            },

            // Search
            search_titles: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'In Titles'
            },
            search_content: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'In Content'
            },
            search_fields: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'In Custom Fields'
            },
            search_comments: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'In Comments'
            },
            search_post_types: {
                type: 'hidden'
            },
            search_categories: {
                type: 'hidden'
            },
            search_pages_exclude: {
                type: 'text',
                label: 'Exclude pages',
                after: 'Comma Separated list of IDs'
            },

            // Other settings
            admin_bar: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Admin bar',
                after: 'Show WordPress admin bar?'
            },
            capabilities: {
                type: 'select',
                label: 'Role',
                class: 'col-md-12',
                variants: {
                    manage_options: 'Admin',
                    edit_pages: 'Editor',
                    publish_posts: 'Author',
                },
                after: 'Minimun user role to access Owl Menu admin page'
            },
        },

        // Content
        content: {
            menu_logo: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Logo',
            },
            menu_logo_type: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Logo',
                variants: {
                    text: 'Text',
                    image: 'Image'
                },
                before: 'This logo is displayed on Top Bar'
            },
            menu_logo_text: {
                type: 'text',
                class: 'col-md-12',
                label: 'Logo Text'
            },
            menu_logo_image: {
                type: 'media',
                class: 'col-md-12',
                label: 'Logo Image',
                button_label: '<span class="dashicons dashicons-upload"></span>',
            },
            menu_menu: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Menu',
            },
            menu_menu_slug: {
                type: 'select',
                class: 'col-md-12',
                label: 'Menu',
                variants: {}
            },
            menu_search: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Search',
            },
            menu_button: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Button',
            },
            menu_button_label: {
                type: 'text',
                class: 'col-md-12',
                label: 'Button label'
            },
            menu_button_url: {
                type: 'text',
                class: 'col-md-12',
                label: 'Button URL'
            },
            menu_social: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Social icons',
            },

            /**
             * Panel
             */

            panel_logo: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Logo',
            },
            panel_logo_type: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Logo',
                variants: {
                    text: 'Text',
                    image: 'Image'
                },
                before: 'This logo is displayed on Sliding Panel'
            },
            panel_logo_text: {
                type: 'text',
                class: 'col-md-12',
                label: 'Logo Text'
            },
            panel_logo_image: {
                type: 'media',
                class: 'col-md-12',
                label: 'Logo Image',
                button_label: '<span class="dashicons dashicons-upload"></span>',
            },
            panel_text: {
                type: 'textarea',
                class: 'col-md-12',
                label: 'Tagline',
                after: 'Leave blank to disable tagline. HTML allowed. Shortcodes allowed.'
            },
            panel_login: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Login form'
            },
            panel_subscribe: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Subscribe form'
            },
            panel_subscribe_welcome_text: {
                type: 'textarea',
                class: 'col-md-12',
                label: 'Intro text',
                after: 'Leave blank to disable intro. HTML allowed. Shortcodes allowed.'
            },
            panel_subscribe_button_text: {
                type: 'text',
                class: 'col-md-12',
                label: 'Button label'
            },
            panel_subscribe_success_text: {
                type: 'text',
                class: 'col-md-12',
                label: 'Success message'
            },
            panel_cart: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Shopping cart'
            },
            panel_menu: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Menu'
            },
            panel_menus: {
                type: 'hidden',
            },
            panel_search: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Search field'
            },
            panel_social: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Social icons'
            },
            panel_footer: {
                type: 'textarea',
                class: 'col-md-12',
                label: 'Footer',
                after: 'Leave blank to disable footer. HTML allowed. Shortcodes allowed.'
            },

            /*
            Search
             */

            search_results: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Search results'
            },
            search_menu: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Show menu'
            },
            search_menu_slug: {
                type: 'select',
                class: 'col-md-12',
                label: 'Menu',
                variants: {}
            },
        },

        // Accounts

        accounts: {
            social: {
                type: 'hidden'
            },
            mailchimp_key: {
                type: 'text',
                label: 'API key',
            },
            mailchimp_list: {
                type: 'select',
                label: 'List',
                class: 'col-md-12',
                variants: {},
            }
        },

        // Styles
        styles: {
            // General
            general_mode: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Menu Mode',
                variants: {
                    menu: 'Bar',
                    button: 'Panel',
                    hidden: 'Hidden',
                },
                before: 'Choose how menu will be shown: as full-width panel or as hamburger button.'
            },

            // Button
            button_fixed: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Fixed'
            },
            button_mode: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Button Mode',
                variants: {
                    icon: 'Icon',
                    text: 'Text',
                }
            },
            button_position: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Position',
                variants: {
                    left: '<svg class="icon dashicons icon-align-v-top"><use xlink:href="#icon-align-h-left"></use></svg>',
                    right: '<svg class="icon dashicons icon-align-v-bottom"><use xlink:href="#icon-align-h-right"></use></svg>'
                }
            },
            button_size: {
                type: 'number',
                label: 'Size'
            },
            button_shift_v: {
                type: 'number',
                label: 'Vertical Shift'
            },
            button_shift_h: {
                type: 'number',
                label: 'Horizontal Shift'
            },
            button_shape: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Shape',
                variants: {
                    square: '<svg class="icon dashicons icon-image-square"><use xlink:href="#icon-image-square"></use></svg>',
                    rounded: '<svg class="icon dashicons icon-image-rounded"><use xlink:href="#icon-image-rounded"></use></svg>',
                    round: '<svg class="icon dashicons icon-image-round"><use xlink:href="#icon-image-round"></use></svg>',
                }
            },
            button_shadow: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Shadow'
            },
            button_shadow_type: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Shadow type',
                variants: {
                    blurred: 'Blurred',
                    solid: 'Solid',
                }
            },
            button_text: {
                type: 'text',
                label: 'Text',
            },
            button_text_family: {
                type: 'font',
                class: 'col-md-12',
                label: 'Font',
            },
            button_text_size: {
                type: 'text',
                class: 'col-md-2',
                label: 'Size'
            },
            button_text_weight: {
                type: 'chooser',
                variants: {
                    300: '<span style="font-weight: 300;">300',
                    400: '400',
                    700: '<span style="font-weight: 700;">700</span>',
                },
                class: 'col-md-2',
                label: 'Weight'
            },
            button_text_style: {
                type: 'chooser',
                variants: {
                    normal: 'Normal',
                    italic: '<i>Italic</i>',
                },
                class: 'col-md-2',
                label: 'Style'
            },
            button_text_transform: {
                type: 'chooser',
                variants: {
                    none: 'Aa',
                    uppercase: 'AA',
                },
                class: 'col-md-2',
                label: 'Transform'
            },
            button_text_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Color'
            },
            button_text_hover_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Hover Color'
            },
            button_bg: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Background'
            },
            button_bg_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Bg Color'
            },
            button_bg_hover_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Bg Hover Color'
            },
            button_border: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Border'
            },
            button_border_size: {
                type: 'number',
                label: 'Size'
            },
            button_border_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Color'
            },
            button_border_hover_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Hover color'
            },

            // Menu
            menu_height: {
                type: 'number',
                label: 'Height',
            },
            menu_adaptive_height: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Adaptive height',
            },
            menu_adaptive_height_amount: {
                type: 'number',
                class: 'col-md-12',
                label: 'Adaptive height',
            },
            menu_adaptive_height_treshold: {
                type: 'number',
                class: 'col-md-12',
                label: 'Adaptive threshold',
                after: 'Amount of pixels you need to scroll down to change menu height. Zero makes menu height always changed.'
            },
            menu_fixed: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Fixed',
            },
            menu_push: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Push page'
            },
            menu_fixed_treshold: {
                type: 'number',
                class: 'col-md-12',
                label: 'Scroll Threshold',
                after: 'Amount of pixels you need to scroll down to make menu visible. Zero makes panel always visible.'
            },
            menu_transparent: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Transparent'
            },
            menu_transparent_treshold: {
                type: 'number',
                class: 'col-md-12',
                label: 'Transp. threshold',
                after: 'Amount of pixels you need to scroll down to make panel background solid again.'
            },
            menu_image: {
                type: 'media',
                class: 'col-md-12',
                label: 'Image',
                button_label: '<span class="dashicons dashicons-upload"></span>',
            },
            menu_image_position: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Image position',
                variants: {
                    top: '<svg class="icon dashicons icon-align-v-top"><use xlink:href="#icon-align-v-top"></use></svg>',
                    center: '<svg class="icon dashicons icon-align-v-center"><use xlink:href="#icon-align-v-center"></use></svg>',
                    bottom: '<svg class="icon dashicons icon-align-v-bottom"><use xlink:href="#icon-align-v-bottom"></use></svg>'
                }
            },
            menu_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Background'
            },
            menu_dropdown_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Dropdown'
            },
            menu_border: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Border'
            },
            menu_border_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Border color'
            },
            menu_shadow: {
                type: 'switcher',
                class: 'col-md-2',
                transparent: true,
                label: 'Shadow'
            },
            menu_mobile_treshold: {
                type: 'number',
                class: 'col-md-2',
                label: 'Mobile Threshold',
                after: 'Mobile mode will be enabled if screen size is smaller than value.'
            },

            // Hidden

            hidden_trigger: {
                type: 'text',
                class: 'col-md-2',
                label: 'Trigger',
                after: 'Any valid CSS selector'
            },
            hidden_target: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Target',
                variants: {
                    menu: 'Top bar',
                    panel: 'Panel',
                }
            },

            // Logo
            menu_logo_text_family: {
                type: 'font',
                class: 'col-md-12',
                label: 'Font',
            },
            menu_logo_text_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Color'
            },
            menu_logo_text_hover_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Hover Color'
            },
            menu_logo_text_size: {
                type: 'text',
                class: 'col-md-2',
                label: 'Size'
            },
            menu_logo_text_weight: {
                type: 'chooser',
                variants: {
                    300: '<span style="font-weight: 300;">300',
                    400: '400',
                    700: '<span style="font-weight: 700;">700</span>',
                },
                class: 'col-md-2',
                label: 'Weight'
            },
            menu_logo_text_style: {
                type: 'chooser',
                variants: {
                    normal: 'Normal',
                    italic: '<i>Italic</i>',
                },
                class: 'col-md-2',
                label: 'Style'
            },
            menu_logo_text_transform: {
                type: 'chooser',
                variants: {
                    none: 'Aa',
                    uppercase: 'AA',
                },
                class: 'col-md-2',
                label: 'Transform'
            },
            menu_logo_shadow: {
                type: 'switcher',
                class: 'col-md-2',
                transparent: true,
                label: 'Shadow'
            },

            // Menus
            menu_menu_align: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Position',
                variants: {
                    left: '<svg class="icon dashicons icon-align-left"><use xlink:href="#icon-align-left"></use></svg>',
                    center: '<svg class="icon dashicons icon-align-center"><use xlink:href="#icon-align-center"></use></svg>',
                    right: '<svg class="icon dashicons icon-align-right"><use xlink:href="#icon-align-right"></use></svg>',
                }
            },
            menu_menu_text_family: {
                type: 'font',
                class: 'col-md-12',
                label: 'Font',
            },
            menu_menu_text_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Color'
            },
            menu_menu_text_hover_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Hover Color'
            },
            menu_menu_text_size: {
                type: 'text',
                class: 'col-md-2',
                label: 'Size'
            },
            menu_menu_text_weight: {
                type: 'chooser',
                variants: {
                    300: '<span style="font-weight: 200 !important;">300',
                    400: '400',
                    700: '<span style="font-weight: 700;">700</span>',
                },
                class: 'col-md-2',
                label: 'Weight'
            },
            menu_menu_text_style: {
                type: 'chooser',
                variants: {
                    normal: 'Normal',
                    italic: '<i>Italic</i>',
                },
                class: 'col-md-2',
                label: 'Style'
            },
            menu_menu_text_transform: {
                type: 'chooser',
                variants: {
                    none: 'Aa',
                    uppercase: 'AA',
                },
                class: 'col-md-2',
                label: 'Transform'
            },
            menu_menu_shadow: {
                type: 'switcher',
                class: 'col-md-2',
                transparent: true,
                label: 'Shadow'
            },

            // Menu Social icons

            menu_social_size: {
                type: 'number',
                class: 'col-md-2',
                label: 'Size'
            },
            menu_social_shape: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Shape',
                variants: {
                    square: '<svg class="icon dashicons icon-image-square"><use xlink:href="#icon-image-square"></use></svg>',
                    rounded: '<svg class="icon dashicons icon-image-rounded"><use xlink:href="#icon-image-rounded"></use></svg>',
                    round: '<svg class="icon dashicons icon-image-round"><use xlink:href="#icon-image-round"></use></svg>',
                }
            },
            menu_social_color: {
                type: 'color',
                class: 'col-md-12',
                label: 'Text'
            },

            // Menu custom button

            menu_button_height: {
                type: 'number',
                label: 'Height',
            },
            menu_button_shape: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Shape',
                variants: {
                    square: '<svg class="icon dashicons icon-image-square"><use xlink:href="#icon-image-square"></use></svg>',
                    rounded: '<svg class="icon dashicons icon-image-rounded"><use xlink:href="#icon-image-rounded"></use></svg>',
                    round: '<svg class="icon dashicons icon-image-round"><use xlink:href="#icon-image-round"></use></svg>',
                }
            },
            menu_button_text_color: {
                type: 'color',
                class: 'col-md-12',
                label: 'Text'
            },
            menu_button_bg_color: {
                type: 'color',
                class: 'col-md-12',
                label: 'Background'
            },
            menu_button_border_color: {
                type: 'color',
                class: 'col-md-12',
                label: 'Border'
            },
            menu_button_text_hover_color: {
                type: 'color',
                class: 'col-md-12',
                label: 'Text Hover'
            },
            menu_button_bg_hover_color: {
                type: 'color',
                class: 'col-md-12',
                label: 'BG Hover'
            },
            menu_button_border_hover_color: {
                type: 'color',
                class: 'col-md-12',
                label: 'Border Hover'
            },

            // Search Button

            search_button_type: {
                type: 'chooser',
                variants: {
                    button: 'Button',
                    field: 'Field',
                },
                class: 'col-md-2',
                label: 'Type'
            },
            search_button_label: {
                type: 'text',
                class: 'col-md-2',
                label: 'Label'
            },
            search_button_size: {
                type: 'number',
                class: 'col-md-2',
                label: 'Size'
            },
            search_button_color: {
                type: 'color',
                class: 'col-md-12',
                label: 'Color'
            },
            search_button_bg_color: {
                type: 'color',
                class: 'col-md-12',
                label: 'Background'
            },
            search_button_animation: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Hover effect'
            },

            // Search Results
            search_results_label: {
                type: 'text',
                class: 'col-md-2',
                label: 'Label'
            },
            search_results_align: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Align',
                variants: {
                    left: '<svg class="icon dashicons icon-align-left"><use xlink:href="#icon-align-left"></use></svg>',
                    center: '<svg class="icon dashicons icon-align-center"><use xlink:href="#icon-align-center"></use></svg>',
                    right: '<svg class="icon dashicons icon-align-right"><use xlink:href="#icon-align-right"></use></svg>',
                }
            },
            search_results_text_family: {
                type: 'font',
                class: 'col-md-12',
                label: 'Font',
            },
            search_results_text_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Color'
            },
            search_results_text_hover_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Hover Color'
            },
            search_results_text_size: {
                type: 'text',
                class: 'col-md-2',
                label: 'Size'
            },
            search_results_text_weight: {
                type: 'chooser',
                variants: {
                    300: '<span style="font-weight: 200 !important;">300',
                    400: '400',
                    700: '<span style="font-weight: 700;">700</span>',
                },
                class: 'col-md-2',
                label: 'Weight'
            },
            search_results_text_style: {
                type: 'chooser',
                variants: {
                    normal: 'Normal',
                    italic: '<i>Italic</i>',
                },
                class: 'col-md-2',
                label: 'Style'
            },
            search_results_text_transform: {
                type: 'chooser',
                variants: {
                    none: 'Aa',
                    uppercase: 'AA',
                },
                class: 'col-md-2',
                label: 'Transform'
            },
            search_results_thumbs_visible: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Thumbnails'
            },
            search_results_thumbs_size: {
                type: 'number',
                class: 'col-md-2',
                label: 'Size'
            },
            search_results_title_visible: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Titles'
            },
            search_results_excerpt_visible: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Excerpt'
            },
            search_results_author_visible: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Author'
            },
            search_results_comments_visible: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Comments Count'
            },
            search_results_date_visible: {
                type: 'switcher',
                class: 'col-md-12',
                transparent: true,
                label: 'Date'
            },

            // Search Results Quick Menu
            search_menu_label: {
                type: 'text',
                class: 'col-md-12',
                label: 'Label',
                variants: {}
            },
            search_menu_list_type: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'List Style',
                variants: {
                    none: '<svg class="icon dashicons icon-list-none"><use xlink:href="#icon-list-none"></use></svg>',
                    ordered: '<svg class="icon dashicons icon-list-ordered"><use xlink:href="#icon-list-ordered"></use></svg>',
                    unordered: '<svg class="icon dashicons icon-list-unordered"><use xlink:href="#icon-list-unordered"></use></svg>'
                }
            },
            search_menu_align: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Position',
                variants: {
                    left: '<svg class="icon dashicons icon-align-left"><use xlink:href="#icon-align-left"></use></svg>',
                    center: '<svg class="icon dashicons icon-align-center"><use xlink:href="#icon-align-center"></use></svg>',
                    right: '<svg class="icon dashicons icon-align-right"><use xlink:href="#icon-align-right"></use></svg>',
                }
            },
            search_menu_text_family: {
                type: 'font',
                class: 'col-md-12',
                label: 'Font',
            },
            search_menu_text_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Color'
            },
            search_menu_text_hover_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Hover Color'
            },
            search_menu_text_size: {
                type: 'text',
                class: 'col-md-2',
                label: 'Size'
            },
            search_menu_text_weight: {
                type: 'chooser',
                variants: {
                    300: '<span style="font-weight: 200 !important;">300',
                    400: '400',
                    700: '<span style="font-weight: 700;">700</span>',
                },
                class: 'col-md-2',
                label: 'Weight'
            },
            search_menu_text_style: {
                type: 'chooser',
                variants: {
                    normal: 'Normal',
                    italic: '<i>Italic</i>',
                },
                class: 'col-md-2',
                label: 'Style'
            },
            search_menu_text_transform: {
                type: 'chooser',
                variants: {
                    none: 'Aa',
                    uppercase: 'AA',
                },
                class: 'col-md-2',
                label: 'Transform'
            },

            // Panel

            panel_width: {
                type: 'number',
                class: 'col-md-2',
                label: 'Width'
            },
            panel_text_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Text'
            },
            panel_bg_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Background'
            },
            panel_image: {
                type: 'media',
                class: 'col-md-12',
                label: 'Image',
                button_label: '<span class="dashicons dashicons-upload"></span>',
            },
            panel_menu_align: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Position',
                variants: {
                    left: '<svg class="icon dashicons icon-align-left"><use xlink:href="#icon-align-left"></use></svg>',
                    center: '<svg class="icon dashicons icon-align-center"><use xlink:href="#icon-align-center"></use></svg>',
                    right: '<svg class="icon dashicons icon-align-right"><use xlink:href="#icon-align-right"></use></svg>',
                }
            },
            panel_menu_text_family: {
                type: 'font',
                class: 'col-md-12',
                label: 'Font',
            },
            panel_menu_text_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Color'
            },
            panel_menu_text_hover_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Hover Color'
            },
            panel_menu_bg_hover_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'BG Hover Color'
            },
            panel_menu_text_size: {
                type: 'text',
                class: 'col-md-2',
                label: 'Size'
            },
            panel_menu_text_weight: {
                type: 'chooser',
                variants: {
                    300: '<span style="font-weight: 200 !important;">300',
                    400: '400',
                    700: '<span style="font-weight: 700;">700</span>',
                },
                class: 'col-md-2',
                label: 'Weight'
            },
            panel_menu_text_style: {
                type: 'chooser',
                variants: {
                    normal: 'Normal',
                    italic: '<i>Italic</i>',
                },
                class: 'col-md-2',
                label: 'Style'
            },
            panel_menu_text_transform: {
                type: 'chooser',
                variants: {
                    none: 'Aa',
                    uppercase: 'AA',
                },
                class: 'col-md-2',
                label: 'Transform'
            },
            panel_menu_gaps: {
                type: 'text',
                class: 'col-md-2',
                label: 'Gaps'
            },

            // Menu Social icons

            panel_social_size: {
                type: 'number',
                class: 'col-md-2',
                label: 'Size'
            },
            panel_social_shape: {
                type: 'chooser',
                class: 'col-md-12',
                label: 'Shape',
                variants: {
                    square: '<svg class="icon dashicons icon-image-square"><use xlink:href="#icon-image-square"></use></svg>',
                    rounded: '<svg class="icon dashicons icon-image-rounded"><use xlink:href="#icon-image-rounded"></use></svg>',
                    round: '<svg class="icon dashicons icon-image-round"><use xlink:href="#icon-image-round"></use></svg>',
                }
            },
            panel_social_color: {
                type: 'color',
                class: 'col-md-2',
                label: 'Color'
            },
        }
    }
})